import { useEffect, useState } from 'react'
import { inject, observer } from 'mobx-react';
import FormMaster from '../FormMaster'
import { CommonService } from "../../../services";
import { isEmpty } from 'lodash';
import { useTranslation } from 'react-i18next'

let firstRender = false
const CostType = inject("authenStore")(observer((props) => {
  const { t } = useTranslation(['cost-type', 'common'])
  let authenStore = props.authenStore
  let { getAccountAuth } = authenStore // STATE
  let auth = { action_user_id: getAccountAuth?.user_id, token_id: getAccountAuth?.access_token }

  const [masterOptions, setMasterOptions] = useState({
    common_status: [],
    cost_group: []
  })

  useEffect(() => {
    if (firstRender || !isEmpty(getAccountAuth)) {
      CommonService.getMasterData(auth, "common_status,cost_group")
        .then((res: any) => {
          let common_status = res.result.common_status.map((item) => ({ label: item.status_name, value: item.status_code }))
          let cost_group = res.result.cost_group.map((item) => ({ label: item.cost_group_name, value: item.cost_group_id }))
          setMasterOptions({
            ...masterOptions,
            common_status,
            cost_group
          })
        })
        .catch((err) => {
          console.log(`Load master data : ${err}`)
        })
    }
    else
      firstRender = true
  }, [getAccountAuth])

  return <FormMaster
    title={t('expense_type_information')}
    tableConfig={{
      key: "id",
      apiPath: "cost_item/list",
      allowDelete: {
        visible: true,
        key: "cost_id",
        apiPath: "cost_item/delete",
        paramType: 'param'
      },
      optionDeleteFag: true,
      defaultColumn: [],
      columns: [
        {
          dataField: 'no',
          caption: t('no'),
          width: 60,
          alignment: "center",
          allowFiltering: false
        },
        {
          dataField: 'code',
          caption: "รหัสประเภท",
          allowFiltering: true
        },
        {
          dataField: 'cost_name',
          caption: t('expense_type_name'),
          allowFiltering: true
        },
        {
          dataField: 'cost_group_name',
          caption: t('expense_group'),
          allowFiltering: true
        },
        {
          dataField: 'status',
          caption: t('status'),
          allowFiltering: true,
          cellRender: (e) => e.value === "Y" ? 'ใช้งาน' : 'ไม่ใช้งาน'
        },
        {
          dataField: 'updated_by',
          caption: t('edit_by'),
        }
      ],
      exportExcel: {
        fileName: t('expense_type_information'),
        columnConfig: [
          { label: t('no'), value: 'no' },
          { label: t('expense_type_code'), value: 'code' },
          { label: t('expense_type_name'), value: 'cost_name' },
          { label: t('expense_group'), value: 'cost_group_name' },
          { label: t('status'), value: (col) => (col.status === "Y" ? 'ใช้งาน' : 'ไม่ใช้งาน') },
          { label: t('edit_by'), value: 'updated_by' }
        ]
      }
    }}
    formData={{
      cost_name: "",
      code: "",
      cost_group_id: "",
      status: "Y"
    }}
    modalConfig={{
      visible: true,
      title: t('expense_type_information'),
      required: ["code", "cost_name", "cost_group_id"],
      fieldTypeNumber: [],
      paramName: "cost_id",
      apiPath: {
        "get": '',
        "post": 'cost_item/add',
        "put": 'cost_item/update'
      },
      elements: [
        {
          fieldName: "code",
          label: t('expense_type_code'),
          placeholder: t('expense_type_code'),
          required: true,
          inputType: "text",
          isOneRow: true
        },
        {
          fieldName: "cost_name",
          label: t('expense_type_name'),
          placeholder: t('expense_type_name'),
          required: true,
          inputType: "text",
          isOneRow: true
        },
        {
          showSearch: false,
          fieldName: "cost_group_id",
          required: true,
          label: t('expense_group'),
          placeholder: t('expense_group'),
          inputType: "select",
          isOneRow: true,
          options: masterOptions.cost_group
        },
        {
          showSearch: false,
          fieldName: "status",
          label: t('status'),
          inputType: "select",
          defaultValue: "Y",
          isOneRow: true,
          options: masterOptions.common_status
        }
      ]
    }}
  />
}))

export default CostType